/**
 * Motion policy: `dur()` for gameplay-essential motion (shortened under reduced motion),
 * `deco()` for decorative motion (removed under reduced motion). Test hooks can zero both.
 */
import { app } from '../game/context.js';

export function reducedMotion(): boolean {
  return app().services.store.state.settings.reducedMotion;
}

export function instant(): boolean {
  return app().flags.skipAnimations;
}

export function dur(ms: number): number {
  if (instant()) return 0;
  return reducedMotion() ? Math.round(ms * 0.6) : ms;
}

export function deco(ms: number): number {
  if (instant() || reducedMotion()) return 0;
  return ms;
}

/**
 * UX-critical sequencing on the WALL clock (PRD timings such as "win screen within 500 ms",
 * "build takes 1 s" are wall-clock). Phaser's scene clock clamps and smooths frame deltas,
 * so it runs slow whenever frames drop; tweens may stay frame-based, flows must not.
 */
export function wait(ms: number): Promise<void> {
  const d = instant() ? 0 : ms;
  if (d <= 0) return Promise.resolve();
  return new Promise((r) => setTimeout(r, d));
}

/** Wait for `p`, but never longer than `ms` of wall time (animations may lag under load). */
export function atMost(p: Promise<unknown>, ms: number): Promise<void> {
  return Promise.race([p.then(() => undefined), wait(ms)]);
}
